Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const featureWorkers_1 = require("../utils/featureWorkers");
const shared = require("@volar/shared");
function register(context) {
    return (uri, position) => {
        return (0, featureWorkers_1.languageFeatureWorker)(context, uri, position, (position, map) => map.toGeneratedPositions(position, data => !!data.completion), (plugin, document, position) => { var _a; return (_a = plugin.findLinkedEditingRanges) === null || _a === void 0 ? void 0 : _a.call(plugin, document, position); }, (data, map) => map ? ({
            wordPattern: data.wordPattern,
            ranges: data.ranges.map(range => map.toSourceRange(range)).filter(shared.notEmpty),
        }) : data);
    };
}
exports.register = register;
//# sourceMappingURL=linkedEditingRanges.js.map